export default __webpack_public_path__ + "static/media/Emblem_Diamond.60650d76.webp";